import { FaPlayCircle } from "react-icons/fa";
import { useGlobalState } from "../../state";
import SwitchRow from "../shared/SwitchRow";

export default function DirectplaySettingsRow() {
  const { directplay, setDirectplay } = useGlobalState();

  return (
    <SwitchRow
      title={"Direct Play"}
      icon={<FaPlayCircle size={20} className="mr-2 text-red-700" />}
      isActive={directplay}
      onChange={() => {
        setDirectplay(!directplay);
      }}
    >
      <span className="text-slate-500 text-sm">
        {
          "Start the playback directly by clicking on a track in the file list. If this is deactivated, each track has to be manually started in the player"
        }
      </span>
    </SwitchRow>
  );
}
